let jsonObjec = "";

export async function surfLogParsingEngine(jsonFilesContent, dataFilesContent) {
  // Simulating a long-running task with a delay
  return new Promise((resolve) => {
    setTimeout(() => {
      let surfType;
      let connectors;
      let dependentIndexs;
      let dependentIndexValue;
      let primaryDependentIndex;
      let numberOfDependentElementnts;
      let headers_Exception;
      let outputString = "";
      let lastexceptionVaules = undefined;
      let lastjsonindex = undefined;
      let lastjsonflag = undefined;
      let firstloopattempt = true;

      if (dataFilesContent) {
        Object.entries(dataFilesContent).forEach(
          ([key, value], index, array) => {
            let targetJson = Object.entries(jsonFilesContent)
              .filter(([jsonkey, jsonvalue]) => {
                if (key.includes(jsonkey)) {
                  lastjsonflag = jsonkey; // Store jsonkey here
                  return true;
                }
                return false;
              })
              .map(([jsonkey, jsonvalue]) => jsonvalue);

            //console.log("targetJson");
            //console.log(lastjsonflag);
            if (targetJson.length != 0) {
              // Remove null character
              // Ensure property names are double-quoted
              // Remove trailing commas before closing curly braces and square brackets
              // remove the null byte and anything else after it
              let cleanedData = targetJson[0]
                .replace(/\x00/g, "")
                .replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":')
                .replace(/,\s*([\]}])/g, "$1")
                .replace(/\0.*$/g, "")
                .replace(/\u0000/g, ""); // Remove null characters
              //.replace(/,\s*([\]}])/g, "$1") // Remove trailing commas before closing brackets
              //.replace(/([a-zA-Z0-9_]+)\s*:/g, '"$1":') // Ensure keys are quoted
              //.replace(/,\s*$/, "") // Remove trailing commas at the end of the string
              //.replace(/\]\s*\[/g, "],[") // Ensure arrays are separated properly
              //.replace(/}\s*{/g, "},{") // Ensure objects are separated properly
              //.replace(/,\s*(?=[}\]])/g, "") // Remove commas before closing brackets
              //.replace(/\n/g, ""); // Remove newline characters if any

              //console.log(cleanedData);

              try {
                jsonObjec = JSON.parse(cleanedData);
              } catch (parseError) {
                resolve({
                  error: `Failed to parse JSON for key ${key}: ${parseError.message}`,
                });
                return;
              }
              //console.log(lastjsonflag);
              //console.log(`index: ${index} len: ${array.length}`);
              //console.log(`Key: ${key}`);
              let segmentSize = 0;
              let segment = [];
              for (let i = 0; i < value.length; ) {
                segmentSize = (value[i] & 0xff) | ((value[i + 1] & 0xff) << 8); // Record len
                segment = value.slice(i, i + segmentSize);
                //console.log(segment);
                /* process log start */
                surfType = checkSurfType();
                connectors = getDepentConnectors("-", surfType);
                dependentIndexs = getDepentIndexs("-", surfType);
                dependentIndexValue = getDepentValueIndex("-", surfType);
                primaryDependentIndex = getPrimaryDepentIndex("-", surfType);
                numberOfDependentElementnts = getNumberOfDepentElement(
                  "-",
                  surfType
                );
                headers_Exception = getHeaderExceptions(segment);
                if (
                  firstloopattempt ||
                  deepArrayComparison(lastexceptionVaules, headers_Exception) ||
                  lastjsonindex != lastjsonflag
                ) {
                  lastexceptionVaules = headers_Exception;
                  lastjsonindex = lastjsonflag; //se tlast json key as flag
                  outputString +=
                    (!firstloopattempt ? "\n" : "") +
                    getHeadersFromJson("-", surfType, headers_Exception) +
                    "\n";
                  firstloopattempt = false;
                }
                outputString +=
                  processLogs(
                    "-",
                    segmentSize,
                    segment,
                    connectors,
                    dependentIndexs,
                    dependentIndexValue,
                    primaryDependentIndex,
                    numberOfDependentElementnts,
                    surfType,
                    headers_Exception
                  ) + "\n";

                /* process log end */
                i += segmentSize; // Move to the next segment
              }
              //console.log(outputString);
            } else {
              resolve({ error: "No JSON file found." });
              return;
            }
          }
        );
      }
      resolve({ value: outputString });
    }, 2000); // 2 seconds delay
  });
}
/*function deepArrayComparison(array1, array2) {
  if (array1 != undefined && array2 != undefined) {
    // Convert arrays to sets of stringified objects for deep comparison
    const set1 = new Set(array1.map((item) => JSON.stringify(item)));
    const set2 = new Set(array2.map((item) => JSON.stringify(item)));

    // Check if both sets have the same size
    if (set1.size !== set2.size) return false;

    // Check if all elements in set1 exist in set2
    for (const item of set1) {
      if (!set2.has(item)) return false;
    }

    return true;
  } else {
    return true;
  }
}*/
function deepArrayComparison(array1, array2) {
  if (!Array.isArray(array1) || !Array.isArray(array2)) return true; // Consider non-arrays as different
  if (array1.length !== array2.length) return true; // Different lengths, arrays are different

  // Convert arrays to sets of stringified objects for deep comparison
  const set1 = new Set(
    array1.map((item) => JSON.stringify(sortObjectKeys(item)))
  );
  const set2 = new Set(
    array2.map((item) => JSON.stringify(sortObjectKeys(item)))
  );

  // Check if any element in set1 is not in set2, indicating arrays are different
  for (const item of set1) {
    if (!set2.has(item)) return true;
  }

  return false; // Arrays are identical
}

// Helper function to sort object keys
function sortObjectKeys(obj) {
  if (obj !== null && typeof obj === "object" && !Array.isArray(obj)) {
    return Object.keys(obj)
      .sort()
      .reduce((result, key) => {
        result[key] = sortObjectKeys(obj[key]);
        return result;
      }, {});
  }
  return obj;
}

function processLogs(
  nodeType,
  presetIndex,
  real,
  connectors,
  dependentIndexs,
  dependentIndexValue,
  primaryDependentIndex,
  numberOfDependentElements,
  surfType,
  headers_Exception
) {
  let currentIndex = 0;
  let primaryDependentID = 0;
  let primaryDependentVal = 0;
  let calculated_json_ind = 0;
  let format,
    sign = "";
  let i = 0;
  let nmbBytes = 0;
  let dependentElementIndex = 0;
  let dependentElementNbBytes = 0;
  let lastnmBytes = 0;
  let bitvalue = 0;
  let dataS = "";
  let dependentString = null;
  let exceptionTable = null;
  let dependentElementJson;

  for (i = 0; currentIndex < presetIndex; i++) {
    //console.log("i"+i+" currentIndex:"+currentIndex+" presetIndex:"+presetIndex);
    if (surfType) {
      nmbBytes = Number(getNumberOfBytes(i, nodeType, surfType));
      format = Number(getDataFormat(i, nodeType, surfType));
      exceptionTable = getDisplayExceptionTable(i, nodeType, surfType);
      sign = Number(getifsigned(i, nodeType, surfType));
    } else {
      nmbBytes = Number(getNumberOfBytes(i, "-", surfType));
      format = Number(getDataFormat(i, "-", surfType));
      exceptionTable = getDisplayExceptionTable(i, "-", surfType);
      sign = Number(getifsigned(i, "-", surfType));
    }
    bitvalue = -1; //initialize with unmatched value
    try {
      bitvalue = Number(getNumberOfBits(i, nodeType, surfType));
    } catch (Exception) {
      bitvalue = -1;
    }

    if (
      headers_Exception == null ||
      (headers_Exception != null && !containsString(headers_Exception, i + ""))
    ) {
      if (getDataVisibility(i, nodeType, surfType) > 0) {
        dataS += getDataValue(
          real,
          format,
          exceptionTable,
          currentIndex,
          nmbBytes,
          sign,
          bitvalue
        );
        if (primaryDependentIndex != null) {
          primaryDependentID = getRealDependentValue(
            real,
            primaryDependentIndex,
            nodeType,
            surfType,
            sign
          );
          primaryDependentVal = getRealDependentValue(
            real,
            dependentIndexValue,
            nodeType,
            surfType,
            sign
          );
          if (
            primaryDependentIndex.data_ind == currentIndex &&
            primaryDependentVal != 0 &&
            primaryDependentVal != 30
          ) {
            for (let z = 0; z < numberOfDependentElements; z++) {
              dataS += " " + connectors[z] + " ";
              dependentElementJson = dependentIndexs[z];
              dependentElementIndex = dependentElementJson.data_ind;
              dependentElementNbBytes = getNumberOfBytes(
                dependentElementJson.json_ind,
                nodeType,
                surfType
              );
              if (primaryDependentVal >= 10) {
                dataS += getDataValue(
                  real,
                  primaryDependentVal,
                  getDisplayExceptionTable(i, nodeType, surfType),
                  dependentElementIndex,
                  dependentElementNbBytes,
                  sign,
                  bitvalue
                );
              } else {
                dataS += getDataValue(
                  real,
                  primaryDependentVal,
                  exceptionTable,
                  dependentElementIndex,
                  dependentElementNbBytes,
                  sign,
                  bitvalue
                );
              }
            }
            dataS += "\t";
          } else {
            dataS += "\t";
          }
        } else {
          dataS += "\t";
        }
      }
    }
    currentIndex += nmbBytes;
  }
  return dataS;
}
function getTotalConnectedNodesIndex() {
  let defaultNode = 0;
  let cun = 0;
  let output = -1;
  let temp;
  let obj = jsonObjec.MappingTable;
  let arr3 = obj[defaultNode.toString()];

  for (let i = 0; i < arr3.length; i++) {
    if (arr3[i][0] == "RS232 Number of Nodes") {
      return cun;
    }
    cun += arr3[i][3];
  }

  return -1;
}
function getNodeType(data) {
  let obj = jsonObjec.MappingIndexes;
  let node = -1;
  let type_index = obj.type_index; // One for function code and two for bytes number supported with web
  let numberBytes = obj.number_byte;
  let indexes = obj.indexes;

  switch (numberBytes) {
    case 1:
      node = data[type_index];
      break;
    case 2:
      node =
        ((data[type_index] & 0xff) | ((data[type_index + 1] & 0xff) << 8)) &
        0xffff;
      break;
    case 4:
      node =
        data[type_index] |
        (data[type_index + 1] << 8) |
        (data[type_index + 2] << 16) |
        (data[type_index + 3] << 24);
      break;
  }

  return indexes[node.toString()];
}
function getNodeTypeFromJson(index) {
  let obj2 = jsonObjec.MappingIndexes.indexes;
  return obj2[index.toString()];
}
function getHeaderExceptions(real) {
  try {
    const headerExceptions = jsonObjec.HeaderExceptions;
    if (headerExceptions != undefined) {
      const dependentIndexArray = headerExceptions[0].Dependent_Index;
      let dependentObject = null;
      let depNbBytes;
      let returnedVal;
      let outputInvisibleFields = [];
      for (let i = 0; i < dependentIndexArray.length; i++) {
        dependentObject = dependentIndexArray[i];
        depNbBytes = getNumberOfBytes(dependentObject.json_ind, "-", false);
        returnedVal = getDataAccordingToNmberOfBytes(
          real,
          parseInt(dependentObject.data_ind),
          parseInt(depNbBytes),
          getifsigned(dependentObject.json_ind, "-", false)
        );
        if (+returnedVal * 1 == dependentObject.Value_Ref) {
          outputInvisibleFields = concatenateArrays(
            outputInvisibleFields,
            dependentObject.Invisible_Fields
          );
          //outputInvisibleFields = mergeCommonValues(outputInvisibleFields);
        }
      }
      return mergeCommonValues(outputInvisibleFields);
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
function concatenateArrays(array1, array2) {
  return array1.concat(array2);
}
function mergeCommonValues(array) {
  return [...new Set(array)];
}
function getAsciiDataAccordingToNmberOfBytes(data, arrayIndex, nmbrBytes) {
  let asciiVal = "";
  for (let i = 0; i < nmbrBytes; i++) {
    asciiVal += String.fromCharCode(data[arrayIndex + i]);
  }
  return asciiVal;
}
function getDataValue(
  dataArr,
  format,
  exception,
  incIndex,
  nbBytes,
  sign,
  bitvalue
) {
  let temp = "";
  let checkFormat = -1;
  let flt;
  let len = 0;
  let tb;
  let data = "";
  //console.log();
  if (bitvalue != -1) {
    return ((parseInt(dataArr[incIndex]) >> bitvalue) & 0x01) == 0
      ? "False"
      : "True";
  }

  if (format == 0) {
    data = getAsciiDataAccordingToNmberOfBytes(dataArr, incIndex, nbBytes);
    return data;
  } else {
    data = getDataAccordingToNmberOfBytes(
      dataArr,
      incIndex,
      nbBytes,
      sign
    ).toString();
  }

  if (exception != null) {
    len = exception.length;
    for (let r = 0; r < len; r++) {
      tb = exception[r];
      if (data == tb.Old_val) {
        checkFormat = r;
        break;
      } else {
        checkFormat = -1;
      }
    }
  } else {
    checkFormat = -1;
  }

  if (checkFormat == -1) {
    let num = parseInt(data);
    switch (format) {
      case 1:
        temp = num.toString();
        break;
      case 2:
        flt = num / 10;
        temp = flt.toFixed(1);
        break;
      case 3:
        flt = num / 100;
        temp = flt.toFixed(2);
        break;
      case 4:
        flt = num / 1000;
        temp = flt.toFixed(3);
        break;
      case 6:
        for (let i = incIndex; i < nbBytes + incIndex; i++) {
          temp += String.fromCharCode(dataArr[i]);
        }
        break;
      case 7:
        temp = formatDateUTC(num * 1000);
        break;
      case 9:
        temp = calculateTime(num);
        break;
      default:
        if (format >= 10) {
          temp = getArrayAccordingToItsIndex(format.toString(), num.toString());
        }
        break;
    }
  } else {
    tb = exception[checkFormat];
    temp = tb.New_val;
  }
  return temp;
}
function getDataAccordingToNmberOfBytes(data, arrayIndex, nmbrBytes, sign) {
  let temp = -1;
  switch (nmbrBytes) {
    case 1:
      temp = data[arrayIndex] & 0xff;
      if (sign == "1") {
        // handling negative values
        if ((temp & 0x80) > 0) temp -= 0x100;
      }
      break;
    case 2:
      temp =
        ((data[arrayIndex] & 0xff) | ((data[arrayIndex + 1] & 0xff) << 8)) &
        0xffff;
      if (sign == "1") {
        // handling negative values
        if ((temp & 0x8000) > 0) temp -= 0x10000;
      }
      break;
    case 4:
      temp =
        (data[arrayIndex] & 0xff) |
        ((data[arrayIndex + 1] & 0xff) << 8) |
        ((data[arrayIndex + 2] & 0xff) << 16) |
        ((data[arrayIndex + 3] & 0xff) << 24);
      if (sign == "1") {
        // handling negative values
        if ((temp & 0x80000000) > 0) temp -= 0xffffffff + 1;
      } else {
        // not signed
        temp = temp >>> 0; // Ensure unsigned result
      }
      break;
  }
  return temp;
}
function getHeadersFromJson(nodetype, surfType, Exception) {
  let headers = "";

  if (surfType) {
    // 17+9KW
    let arr3 = jsonObjec["MappingTable"][nodetype];
    for (let i = 0; i < arr3.length; i++) {
      if (
        (Exception == null && arr3[i][1] == "1") ||
        (Exception != null &&
          !containsString(Exception, i.toString()) &&
          arr3[i][1] == "1")
      ) {
        // check the visibility before
        if (headers == "") {
          headers = arr3[i][0];
        } else {
          headers = headers + "\t" + arr3[i][0];
        }
      }
    }
    headers = headers + "\t";
  } else {
    let arr = jsonObjec["MappingTable"];
    // Pass through all Elements in MappingTable and extract element_0 to be used as headers for csv file, while checking for visibility
    for (let i = 0; i < arr.length; i++) {
      if (
        (Exception == null && arr[i][1] == "1") ||
        (Exception != null &&
          !containsString(Exception, i.toString()) &&
          arr[i][1] == "1")
      ) {
        // check the visibility before
        if (headers == "") {
          headers = arr[i][0];
        } else {
          headers = headers + "\t" + arr[i][0];
        }
      }
    }
  }

  return headers;
}
function containsString(arr, str) {
  return arr.indexOf(str) !== -1;
}
function checkSurfType() {
  let solar_DC_17_9KW_320 = false;
  if (
    jsonObjec &&
    jsonObjec.hasOwnProperty("MappingIndexes") &&
    jsonObjec["MappingIndexes"] !== null
  ) {
    // Do something with the object
    solar_DC_17_9KW_320 = true;
  } else {
    solar_DC_17_9KW_320 = false;
  }
  return solar_DC_17_9KW_320;
}
function handleNegativeValueUsingSignedValue(value, signed, numbyts) {
  if (signed == "1") {
    // signed value
    let temp = 1 << (parseInt(numbyts) * 8 - 1);
    let cach = parseInt(value);
    if ((cach & temp) !== 0) {
      // negative value
      cach -= 1 << (parseInt(numbyts) * 8);
      return String(cach);
    } else {
      return value;
    }
  } else {
    return value;
  }
}
function getRealDependentValue(
  dataArr,
  dependentHolder,
  nodeType,
  surfType,
  sign
) {
  try {
    let dep_nb_bytes = Number(
      getNumberOfBytes(dependentHolder.json_ind, nodeType, surfType)
    );
    let returnedVal = getDataAccordingToNmberOfBytes(
      dataArr,
      Number(dependentHolder.data_ind),
      Number(dep_nb_bytes),
      sign
    );
    return returnedVal;
  } catch (JSONException) {
    return -1;
  }
}
function containsArrayString(jsonArray, val) {
  try {
    for (let i = 0; i < jsonArray.length; i++) {
      if (jsonArray[i] == val) {
        return true;
      }
    }
  } catch (JSONException) {
    return false;
  }
  return false;
}
function handleNegativeValues(data) {
  return Number(data);
}
function getDisplayExceptionTable(index, nodetype, surfType) {
  try {
    if (surfType) {
      //17+9KW
      let temper = jsonObjec.DispalyExceptionTable[nodetype];
      for (let i = 0; i < temper.length; i++) {
        if (index == temper[i][0]) {
          return temper[i];
        }
      }
    } else {
      let temper = jsonObjec.DispalyExceptionTable;
      for (let i = 0; i < temper.length; i++) {
        if (index == temper[i][0]) {
          return temper[i];
        }
      }
    }
  } catch (JSONException) {
    return null;
  }
  return null;
}
const calculateTime = (num) => {
  const hours = Math.ceil(num / 3600);
  const minutes = Math.ceil((num % 3600) / 60);
  const seconds = Math.ceil(num % 60);

  return `${hours}:${minutes}:${seconds}`;
};
const formatDateUTC = (timestamp) => {
  const date = new Date(timestamp);

  const pad = (num) => String(num).padStart(2, "0");

  const day = pad(date.getUTCDate());
  const month = pad(date.getUTCMonth() + 1);
  const year = date.getUTCFullYear();

  let hours = date.getUTCHours();
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const formattedHours = pad(hours);

  return `${day}-${month}-${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
};
function getDataName(evetIndex, nodeType, surfType) {
  return getEventIdAtSpecifiedIndex(evetIndex, nodeType, surfType)[0];
}
function getDataVisibility(evetIndex, nodeType, surfType) {
  return getEventIdAtSpecifiedIndex(evetIndex, nodeType, surfType)[1];
}
function getDataFormat(evetIndex, nodeType, surfType) {
  return getEventIdAtSpecifiedIndex(evetIndex, nodeType, surfType)[2];
}
function getNumberOfBytes(evetIndex, nodeType, surfType) {
  return getEventIdAtSpecifiedIndex(evetIndex, nodeType, surfType)[3];
}
function getifsigned(evetIndex, nodeType, surfType) {
  return getEventIdAtSpecifiedIndex(evetIndex, nodeType, surfType)[4];
}
function getNumberOfBits(evetIndex, nodeType, surfType) {
  let val = getEventIdAtSpecifiedIndex(evetIndex, nodeType, surfType)[5];
  return val == undefined ? "-1" : val;
}
function getArrayMapingTable() {
  return getObjectMapingTable();
}
function getObjectMapingTable() {
  try {
    return jsonObjec.MappingTable;
  } catch (JSONException) {
    return null;
  }
}
function getArrayAccordingToItsIndex(format, data) {
  try {
    return jsonObjec.StringsTable[0][format][data];
  } catch (Exception) {
    return "";
  }
}
function getDepentValueIndex(nodeType, surfType) {
  let index = 3;
  try {
    if (surfType) {
      //17+9KW
      return jsonObjec.DependencyTable[nodeType][index].Value_index;
    } else {
      return jsonObjec.DependencyTable[index].Value_index;
    }
  } catch (JSONException) {
    return null;
  }
}
function getDepentConnectors(nodeType, surfType) {
  let index = 4;
  try {
    if (surfType) {
      //17+9KW
      return jsonObjec.DependencyTable[nodeType][index].Connectors;
    } else {
      return jsonObjec.DependencyTable[index].Connectors;
    }
  } catch (JSONException) {
    return null;
  }
}
function getDepentIndexs(nodeType, surfType) {
  let index = 2;
  let temp;
  try {
    if (surfType) {
      //17+9KW
      temp = jsonObjec.DependencyTable[nodeType][index].Dep_indeces;
    } else {
      temp = jsonObjec.DependencyTable[index].Dep_indeces;
    }
  } catch (JSONException) {
    return null;
  }
  return temp;
}
function getDependencyTable() {
  return jsonObjec.DependencyTable;
}
function getNumberOfDepentElement(nodeType, surfType) {
  let index = 1;
  let obj2;
  try {
    if (surfType) {
      //17+9KW
      obj2 = jsonObjec.DependencyTable[nodeType][index];
    } else {
      obj2 = jsonObjec.DependencyTable[index];
    }
    return obj2.getInt("Num_dep_elem");
  } catch (JSONException) {
    return -1;
  }
}
function getEventIdAtSpecifiedIndex(eventIndex, nodeType, surfType) {
  let temp = [];
  try {
    let arr = jsonObjec.MappingTable;
    if (surfType) {
      //17+9KW
      temp = arr[nodeType][eventIndex];
    } else {
      temp = arr[eventIndex];
    }
  } catch (Exception) {
    //console.log("null " + Exception + "ev " + eventIndex);
    return null;
  }
  return temp;
}
function getPrimaryDepentIndex(nodeType, surfType) {
  let index = 0;
  try {
    if (surfType) {
      //17+9KW
      return jsonObjec.DependencyTable[nodeType][index]
        .Primary_Dependency_Index;
    } else {
      return jsonObjec.DependencyTable[index].Primary_Dependency_Index;
    }
  } catch (JSONException) {
    return null;
  }
}

/* ------------------------------------------------------------------ *
 * Column-selection post-processing.
 * Operates on the TSV string surfLogParsingEngine already returned.
 * Nothing above this line is aware of it. Keep this file import-free.
 * ------------------------------------------------------------------ */

export const LOG_COLUMN_PREF_PREFIX = "logcols_of_";

function normalizeName(raw) {
  return raw == null ? "" : String(raw).trim();
}

export function logColumnPrefsKey(mac, logType) {
  return LOG_COLUMN_PREF_PREFIX + mac + "_" + logType;
}

/*
 * The engine emits BLOCKS, not one table. surfLogParsingEngine re-emits a
 * header line whenever the hidden-column set or the source JSON changes, and
 * prepends "\n" to it -- so every header after the first is preceded by an
 * empty line (the previous data row already ended in "\n"). This is the exact
 * inverse of that emitter:
 *
 *   header  = non-empty AND (line 0 OR previous line empty)
 *   ""      = separator (also absorbs the trailing element of split("\n"))
 *   else    = data row of the current block
 *
 * Different blocks can carry different column sets, so every keep-set below is
 * computed per block and matched by NAME, never by index across blocks.
 */
function scanTsvBlocks(lines) {
  const blocks = [];
  let current = null;
  for (let i = 0; i < lines.length; i++) {
    if (lines[i] === "") {
      current = null;
      continue;
    }
    if (current === null) {
      current = {
        headerIndex: i,
        header: lines[i],
        names: lines[i].split("\t"),
        rowIndexes: [],
      };
      blocks.push(current);
    } else {
      current.rowIndexes.push(i);
    }
  }
  return blocks;
}

// Ordered, de-duplicated list of every column name in the output. First-seen
// order, so block 0's columns come first in their sheet order.
export function extractLogHeaders(tsv) {
  const seen = new Set();
  const ordered = [];
  scanTsvBlocks(String(tsv == null ? "" : tsv).split("\n")).forEach((block) => {
    let real = 0;
    block.names.forEach((raw) => {
      const name = normalizeName(raw);
      if (name === "") return; // phantom trailing column, see projectLine
      real++;
      if (seen.has(name)) return; // duplicate listed once
      seen.add(name);
      ordered.push(name);
    });
    if (real === 0) {
      console.warn(
        "dataParser: no named columns at line " + block.headerIndex
      );
    }
  });
  return ordered;
}

/*
 * processLogs appends "\t" after EVERY visible field, and getHeadersFromJson
 * adds one too in the surfType branch. So a line's trailing tab is part of the
 * emitter's shape, not a column -- preserve it verbatim rather than trying to
 * correct the index math, which keeps both branches round-tripping exactly.
 */
function projectLine(line, keep) {
  const trailingTab = line.endsWith("\t") ? "\t" : "";
  const cells = line.split("\t");
  let out = "";
  for (let k = 0; k < keep.length; k++) {
    out +=
      (k === 0 ? "" : "\t") +
      (cells[keep[k]] === undefined ? "" : cells[keep[k]]);
  }
  return out + trailingTab;
}

// Drop every column whose name is in hiddenNames. Invariant: passing [] or
// only-unknown names returns the input byte-for-byte.
export function filterLogColumns(tsv, hiddenNames) {
  const source = tsv == null ? "" : String(tsv);
  const hidden = new Set(
    (hiddenNames || []).map(normalizeName).filter(Boolean)
  );
  if (hidden.size === 0) return source;

  const endsWithNewline = source.endsWith("\n");
  const lines = source.split("\n");
  const out = [];

  scanTsvBlocks(lines).forEach((block) => {
    const keep = [];
    block.names.forEach((raw, i) => {
      const name = normalizeName(raw);
      if (name === "" || hidden.has(name)) return;
      keep.push(i);
    });
    // Columns sharing a name share a fate -- name is the only stable identity
    // a name-list picker can offer.
    if (keep.length === 0) return; // drop header, its rows, and its separator

    if (out.length > 0) out.push(""); // REBUILD separators, never copy them
    out.push(projectLine(block.header, keep));
    block.rowIndexes.forEach((r) => out.push(projectLine(lines[r], keep)));
  });

  let result = out.join("\n");
  if (result !== "" && endsWithNewline) result += "\n";
  return result;
}

// 0-based line indexes of the header rows, for DownloadExcel's row styling.
export function getHeaderLineIndexes(tsv) {
  return scanTsvBlocks(String(tsv == null ? "" : tsv).split("\n")).map(
    (b) => b.headerIndex
  );
}

/*
 * Persisted per device + log type. We store the HIDDEN names, not the selected
 * ones: if firmware later adds a column, a stored "selected" list would leave
 * it unticked and silently missing from the export. Storing hidden means new
 * columns default to visible -- the failure mode is one extra column, never one
 * missing column.
 */
export function loadHiddenLogColumns(mac, logType) {
  try {
    const raw = localStorage.getItem(logColumnPrefsKey(mac, logType));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.map(normalizeName).filter(Boolean);
    if (parsed && Array.isArray(parsed.hidden)) {
      return parsed.hidden.map(normalizeName).filter(Boolean);
    }
    return [];
  } catch (e) {
    return []; // a corrupt value must never break the export
  }
}

export function saveHiddenLogColumns(mac, logType, hiddenNames) {
  try {
    const hidden = Array.from(
      new Set((hiddenNames || []).map(normalizeName).filter(Boolean))
    );
    localStorage.setItem(
      logColumnPrefsKey(mac, logType),
      JSON.stringify({ v: 1, hidden: hidden, savedAt: new Date().toISOString() })
    );
  } catch (e) {
    // quota exceeded / Safari private mode: degrade to "not remembered",
    // never block the export
  }
}
